import ReactDOM from "react-dom/client";
import "./styles/global.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Auth0Provider } from "@auth0/auth0-react";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// Function to handle the Auth0 redirect callback
const onRedirectCallback = (appState: any) => {
  // If the application state includes a returnTo property, use it to redirect
  // Otherwise, redirect to the root path
  window.history.replaceState(
    {},
    document.title,
    appState?.returnTo || window.location.pathname,
  );
};

// Get Auth0 configuration from environment variables with fallbacks
const auth0Domain = "login.alpinehomeair.com";
const auth0ClientId =
  process.env.REACT_APP_AUTH0_CLIENT_ID || "Exm1ziEMGCMYuZoHwn1VGp2xph3lIyO8";
const auth0Audience = "pnet-api";

root.render(
  <BrowserRouter>
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: auth0Audience,
        scope: "openid profile email",
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
    >
      <App />
    </Auth0Provider>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
